export function getFirstName(name: string) {
  return name?.split(' ')[0];
}

export function formatAddress(addr: string) {
  return addr?.split(', USA').join('');
}
